import { Button } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/new/components/shadcn/dialog';

interface LegacyContextData {
  legalIssues?: string | null;
  parties?: string | null;
  keyTimePeriod?: string | null;
  keyContext?: string | null;
  disputeStatus?: string | null;
}

interface LegacyContextDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  data: LegacyContextData | undefined;
}

const fields = [
  { key: 'legalIssues', label: 'Issues' },
  { key: 'parties', label: 'Parties' },
  { key: 'keyTimePeriod', label: 'Time Period' },
  { key: 'keyContext', label: 'Key Context' },
  { key: 'disputeStatus', label: 'Dispute Status' },
] as const;

export function hasLegacyContext(data: LegacyContextData | undefined): boolean {
  if (!data) return false;
  return fields.some((f) => !!data[f.key]);
}

export function LegacyContextDialog({ open, onOpenChange, title, data }: LegacyContextDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {fields.map(
            ({ key, label }) =>
              data?.[key] && (
                <div key={key}>
                  <p className="mb-1 text-xs font-medium text-gray-500">{label}</p>
                  <p className="rounded-md border border-gray-200 bg-gray-50 p-3 text-sm whitespace-pre-wrap text-gray-700">
                    {data[key]}
                  </p>
                </div>
              ),
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
